import React from 'react';

import ForgotPasswordForm from '../components/forms/ForgotPasswordForm';
import LoginLayout from '../components/layout/LoginLayout';

const ForgotPassword = () => {
  return (
    <LoginLayout>
      <ForgotPasswordForm />
    </LoginLayout>
  );
};

export default ForgotPassword;
